<div class="masonry" #wall id="wall">
	<ng-content></ng-content>
</div>
